/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useCallback } from "react";
import { Provider } from "react-redux";
import { CategorySearchResult, ResourceSearchResult, BrandSearchResult, PromotedCategoryBrandAd } from "./SearchPageResult";
import SearchImageBox from "./SearchImageBox";
import ResourceLink from "./ResourceLink";
import Store from "~/common/Store";
import { defaultUserObject } from "~/common/Store/rootReducer";
import useIsMounted from "~/common/useIsMounted";
interface Props {
  brands: BrandSearchResult[];
  categories: CategorySearchResult[];
  resources: ResourceSearchResult[];
  promotedCategory?: PromotedCategoryBrandAd;
}
const SearchBrandsCategoriesView = ({
  brands,
  categories,
  resources,
  promotedCategory
}: Props) => {
  const [categoriesText, setCategoriesText] = useState("VIEW MORE CATEGORIES");
  const [expandedClass, setExpandedClass] = useState("");
  const [categoriesExpandedState, setCategoriesExpandedState] = useState(false);
  const [displayViewAllcategoriesLink, setDisplayViewAllcategoriesLink] = useState(false);
  const maxLinksToDisplay = 5;
  const mounted = useIsMounted();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (categoriesText === "VIEW MORE CATEGORIES") {
      setExpandedClass(" expanded");
      setCategoriesText("VIEW LESS CATEGORIES");
      setCategoriesExpandedState(true);
    } else {
      setExpandedClass("");
      setCategoriesText("VIEW MORE CATEGORIES");
      setCategoriesExpandedState(false);
    }
  };
  const getItemsDisplayedIfNotExpanded = useCallback(() => {
    const windowWidth = window.innerWidth;
    let numberOfItemsDisplayed = 0;
    if (windowWidth >= 1900) {
      resources.length > 0 ? numberOfItemsDisplayed = 18 : numberOfItemsDisplayed = 20;
    } else if (windowWidth > 1280 && windowWidth < 1899) {
      resources.length > 0 ? numberOfItemsDisplayed = 14 : numberOfItemsDisplayed = 16;
    } else if (windowWidth > 1024 && windowWidth < 1279) {
      resources.length > 0 ? numberOfItemsDisplayed = 10 : numberOfItemsDisplayed = 12;
    } else if (windowWidth > 946 && windowWidth < 1023) {
      resources.length > 0 ? numberOfItemsDisplayed = 8 : numberOfItemsDisplayed = 10;
    } else if (windowWidth > 600 && windowWidth < 767) {
      numberOfItemsDisplayed = 8;
    } else {
      numberOfItemsDisplayed = 6;
    }
    return numberOfItemsDisplayed;
  }, [resources.length]);
  const updateViewAllStatus = useCallback(() => {
    const itemsDisplayed = getItemsDisplayedIfNotExpanded();
    const totalItems = brands.length + categories.length + brands.reduce((total, brand) => total + brand.categories.length, 0);
    setDisplayViewAllcategoriesLink(totalItems > itemsDisplayed);
  }, [brands, categories.length, getItemsDisplayedIfNotExpanded]);
  useEffect(() => {
    updateViewAllStatus();
    window.addEventListener("resize", updateViewAllStatus);
    return () => {
      window.removeEventListener("resize", updateViewAllStatus);
    };
  }, [brands, categories, updateViewAllStatus]);
  const customCategories = categories.filter(category => category.isCustomTile).map(category => ({
    sortOrder: category.customTileSortOrder,
    element: <SearchImageBox link={category.link} key={category.name} name={category.name} image={category.imageThumbnail} childCount={category.numberOfChildren} childrenAreProducts={category.childrenAreProducts} type="category" mounted={mounted} />
  }));
  const customBrands = brands.filter(brand => brand.isCustomTile).map(brand => ({
    sortOrder: brand.customTileSortOrder,
    element: <SearchImageBox link={brand.link} key={brand.name} name={brand.name} image={brand.image} childCount={brand.productCount} type="brand" mounted={mounted} />
  }));
  const elements = [...customCategories, ...customBrands].sort((a, b) => a.sortOrder - b.sortOrder).map(custom => custom.element);
  return <>
      <div data-no-jquery className={`search__expanded${resources.length > 0 ? " with-resources" : ""}${expandedClass}
        `}>
        <div className="ag ag-category-grid ag-wide box" id="categoriesBox">
          {!!promotedCategory && <Provider store={Store}>
              <SearchImageBox link={promotedCategory.link} key={`promo-ad-${promotedCategory.brandName}`} name={promotedCategory.anchorText} image={promotedCategory.image} childCount={promotedCategory.productCount} childrenAreProducts type="category" isPromotedAd user={defaultUserObject} adId={promotedCategory.adId} mounted={mounted} brandIds={promotedCategory.brandIds} categoryId={promotedCategory.categoryId} categoryName={promotedCategory.categoryName} />
            </Provider>}
          {elements}
          {brands.filter(brand => !brand.isCustomTile).map(brand => <SearchImageBox link={brand.link} key={brand.name} name={brand.name} image={brand.image} childCount={brand.productCount} type="brand" mounted={mounted} />)}
          {brands.flatMap(brand => brand.categories).map(brandCategory => <SearchImageBox link={brandCategory.link} key={brandCategory.name} name={brandCategory.name} image={brandCategory.image} childCount={brandCategory.productCount} childrenAreProducts type="category" mounted={mounted} />)}
          {categories.filter(category => !category.isCustomTile).map(category => <SearchImageBox link={category.link} key={category.name} name={category.name} image={category.imageThumbnail} childCount={category.numberOfChildren} childrenAreProducts={category.childrenAreProducts} type="category" mounted={mounted} />)}
          {resources.length > 0 && <div className="ag__resources">
              <div className="resources">
                <div className="productResources" data-no-jquery>
                  <p className="header-4">Resources</p>
                  <ul className="item-list">
                    {resources.map((resource, index) => <ResourceLink title={resource.title} link={resource.link} key={resource.id} displayResourceLink={index < maxLinksToDisplay} />)}
                  </ul>
                </div>
              </div>
            </div>}
        </div>
      </div>
      {displayViewAllcategoriesLink === true && <button type="button" aria-expanded={categoriesExpandedState} aria-pressed={categoriesExpandedState} aria-controls="categoriesBox" className="search__view-all box" data-no-jquery onClick={handleClick}>
          <span>{categoriesText}</span>
        </button>}
    </>;
};
export default SearchBrandsCategoriesView;